import React from 'react';
import Loading from '~/Components/Loading';
import FormProjeto from './FormProjeto';
import GridExpectativa from './GridExpectativa';
import GridIPTU from './GridIPTU';
import GridEtapas from './GridEtapas';
import GridContasProjeto from './GridContasProjeto';
import GridAreasProjeto from './GridAreasProjeto';

const TabProjeto = ({ codigoFamilia, dados, dadosGerais, permissoes, onSalvar, onRecarregar }) => {
  if (dados == null) return <Loading />;

  const dadosProjeto = dados != null ? dados.dados_projeto : null;
  const projetoComEstagio = dadosProjeto != null
    ? { ...dadosProjeto, estagio: dadosGerais != null ? dadosGerais.estagio : '' }
    : null;

  return (
    <div>
      <FormProjeto
        dados={projetoComEstagio}
        permissoes={permissoes}
        onSalvar={onSalvar}
      />
      <GridContasProjeto
        codigoFamilia={codigoFamilia}
        contasProjeto={dados.contas_projeto != null ? dados.contas_projeto : []}
        permissoes={permissoes}
        onRecarregar={onRecarregar}
      />
      <GridAreasProjeto
        codigoFamilia={codigoFamilia}
        areasProjeto={dados.areas_projeto != null ? dados.areas_projeto : []}
        permissoes={permissoes}
        onRecarregar={onRecarregar}
      />
      <GridExpectativa
        codigoFamilia={codigoFamilia}
        expectativas={dados.expectativas != null ? dados.expectativas : []}
        permissoes={permissoes}
        onRecarregar={onRecarregar}
      />
      <GridEtapas
        codigoFamilia={codigoFamilia}
        etapas={dados.etapas != null ? dados.etapas : []}
        etapasEmpreendimento={dados.etapas_empreendimento != null ? dados.etapas_empreendimento : []}
        permissoes={permissoes}
        onRecarregar={onRecarregar}
      />
      <GridIPTU
        codigoFamilia={codigoFamilia}
        iptu={dados.iptu != null ? dados.iptu : []}
        permissoes={permissoes}
        onRecarregar={onRecarregar}
      />
    </div>
  );
};

export default TabProjeto;
